import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';
import {CatalogAdminPage} from "./catalog-admin.page";
import {AdminGlobalModule} from "../../admin-global-module.module";
import {CatalogManagerComponent} from "./catalog-manager/catalog-manager.component";
import {SectionTreeComponent} from "./catalog-manager/section-tree/section-tree.component";
import {ItemListComponent} from "./catalog-manager/item-list/item-list.component";
import {ItemDetailsComponent} from "./catalog-manager/item-details/item-details.component";
import {SectionBoxComponent} from "./catalog-manager/section-box/section-box.component";

const routes: Routes = [
    {
        path: '',
        component: CatalogAdminPage
    }
];

@NgModule({
    imports: [
        AdminGlobalModule,
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes)
    ],
    exports: [
        CatalogAdminPage
    ],
    declarations: [CatalogAdminPage]
})
export class CatalogAdminPageModule {
}
